module.exports = __webpack_public_path__ + "static/kure2-9971fe2df1b656c00e9dcfa7aa431e21.png";